var scope_0 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/32deeaf17cdea8395865917d81f01967.js').default;
var scope_1 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8d23da629fac14f7ab20f3e1420644ab.js').default;
var scope_2 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b12903ba8b5e6c270478e5ccd5b20bf7.js').default;
var scope_3 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c2492c45e9199b864c95c57809596896.js').default;
var scope_4 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_5 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f4273b2628f3d1f6f4bfbeec8e2a424c.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5 )
    